<template>
  <pt-login class="pt-login__withData" :loginForm="form" ref="loginForm" v-loading="loading" element-loading-text="加载中" :on-login="onLogin">

  </pt-login>
</template>

<script>
import PtLogin from './index'
import { getCookie } from '@/utils/cookie'
export default {
  name: 'pt-login__withData',
  components: {
    'pt-login': PtLogin
  },
  data () {
    return {
      form: {
        username: '', // 'lab_operator',
        password: '', // 'UI3wkq2ORyrDp85HnmoJ',
        rememberMe: true
      },
      loading: false
    }
  },
  methods: {

    onLogin () {
      this.$refs.loginForm.formValidate().then(() => {
        this.loading = true
        // var redirect = this.$auth.redirect()
        let _this = this
        // 使用qs来对json对象序列化，以适应x-www-form-urlencoded
        // var qs = require('qs')
        // 记住账号
        // var rememberStatus = this.form.rememberMe
        this.$auth.login({
          data: this.form,
          rememberMe: true,
          // headers : {'Content-Type':'application/json;charset=UTF-8'},
          // redirect: { name: redirect ? redirect.from.name : '/home' },
          redirect: { name: 'home' },
          success () {
            this.loading = false
            console.log('this.$auth.redirect()--', this.$auth.redirect())
            _this.$message.success('登录成功！')
            // if (rememberStatus) {
            //   console.log('勾选了记住，现在开始写入cookie')
            //   let expireDays = 1000 * 60 * 60 * 24
            //   setCookie('name', this.form.username, expireDays)
            // } else {
            //   console.log('没有勾选记住，删除cookie')
            //   delCookie('name')
            // }
          },
          error (err) {
            this.loading = false
            // 已经发出请求，处理请求结果
            if (err.response) {
              if (err.response.status === 401) {
                _this.$message.error('登录失败，请检查用户名 验证码或密码！')
              } else {
                console.log(err.response)
                _this.$message.error('登录失败！')
              }
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', err.message)
              _this.$message.error('登录失败：' + err.message)
            }
          }
        })
      })
    },
    loadAccountInfo: function () {
      let mySelf = this
      let accountInfo = getCookie('name')
      if (accountInfo) {
        // 如果cookie里有账号信息
        console.log('cookie中检测到账号信息！现在开始预填写！')
        mySelf.form.username = accountInfo
        mySelf.form.rememberMe = true
      }
    }
  },
  mounted: function () {
    // 读取cookie中的账号信息，如果有accountInfo的话，则说明该用户之前勾选了记住帐号的功能，则需要自动填上账号
    this.loadAccountInfo()
  }
}
</script>
